export const ContactData = [
  {
    id: 1,
    title: "For Delivery Learning",
    content: `
        <ul>
          <li>
            <span>DFA 4.0 - </span>
            <span>
              <a href='mailto:sriparna.a.das'>sriparna.a.das</a>, </br>
              <a href="mailto:usha.ks">usha.ks</a>,</br>
              <a href="mailto:Icewariya.s.p">Icewariya.s.p</a>
            </span>
          </li>
          <li><span>SI - </span> <a href='mailto:vineet.sachdev'>vineet.sachdev</a></li>
          <li>
            <span>Techcore - </span> 
            <span>
              <a href='mailto:jinal.ashwin.chheda'>jinal.ashwin.chheda</a>,</br>
              <a href="mailto:smita.rajan">smita.rajan</a>
            </span>
          </li>
          <li>
            <span>Agile -  </span> 
            <span>
              <a href='mailto:sayee.p.subramanian'>sayee.p.subramanian</a>,</br>
              <a href='mailto:ramyasree.puppala'>ramyasree.puppala</a>
            </span>
          </li>
          <li>
          <span>DevOps - </span> 
          <span>
          <a href='mailto:Sreenivasa.cpcl.rao'>Sreenivasa.cpcl.rao</a>,</br>
          <a href='mailto:r.a.perumalsamy'>r.a.perumalsamy</a>
          </span>
          </li>
          <li><span>SRE - </span> 
          <span>
          <a href='mailto:Sreenivasa.cpcl.rao'>Sreenivasa.cpcl.rao</a>,</br>
          <a href='mailto:r.a.perumalsamy'>r.a.perumalsamy</a>
          </span>
          </li>
          <li><span>AMS - </span> 
            <span>
              <a href='mailto:jinal.ashwin.chheda'>jinal.ashwin.chheda</a>,</br>
              <a href='mailto:gayathri.a.ganesh'>gayathri.a.ganesh</a>
            </span>
          </li>
          <li><span>PM - </span> 
            <span>
              <a href='mailto:jinal.ashwin.chheda'>jinal.ashwin.chheda</a>,</br>
              <a href='mailto:devangna.saraswat'>devangna.saraswat</a>
            </span>
          </li>
          <li><span>Delivery Leadership - </span>
            <span>
              <a href='mailto:christinajoyce.dj'>christinajoyce.dj</a>
            </span>
          </li>
        </ul>
      `,
    icon: "images/Contact/new-icons/DeliveryLearning.png",
  },
  {
    id: 2,
    title: "For Enterprise Platforms",
    content: `
        <ul>
          <li>
            <span>SAP -</span> 
            <span>
              <a href='mailto:s.saraswathi'>s.saraswathi</a>,</br>
              <a href='mailto:shyam.bahadur.singh'>shyam.bahadur.singh</a>,</br>
              <a href='mailto:vinitha.raj'>vinitha.raj</a>
            </span>
          </li>
          <li>
            <span>Oracle -</span> 
            <span>
              <a href='mailto:madhuri.gattu'>madhuri.gattu</a>,</br>
              <a href='mailto:arun.ragul.arasan'>arun.ragul.arasan</a>
            </span>
          </li>
          <li>
            <span>Salesforce -</span> 
            <span>
              <a href='mailto:s.saraswathi'>s.saraswathi</a>,</br>
              <a href='mailto:krishna.kishore'>krishna.kishore</a>,</br>
              <a href='mailto:suresh.hn'>suresh.hn</a>
            </span>
          </li>
        </ul>
      `,
    icon: "images/Contact/new-icons/EnterprisePlatforms.png",
  },
  {
    id: 3,
    title: "For Cloud, D&AI",
    content: `
        <ul>
          <li>
          <span>AWS -</span> 
          <span>
          <a href='mailto:gopalamma.allam'>gopalamma.allam</a>,</br>
          <a href='mailto:y.karthigayen'>y.karthigayen</a>,</br>
          <a href='mailto:vinay.n.gupta'>vinay.n.gupta</a>
          </span>
          </li>
          <li>
          <span>Cloud Elevate -</span> 
          <span> 
            <a href='mailto:Seema.Hemant'>Seema.Hemant</a>,</br>
            <a href='mailto:Winifred.Sebastian'>Winifred.Sebastian</a>
          </span> 
          </li>
          <li>
          <span>Azure -</span> 
          <span>
            <a href='mailto:Mathan.Govindarajan'>Mathan.Govindarajan</a>,</br>
            <a href='mailto:Joy.Keren.S'>Joy.Keren.S</a>
          </span>
          </li>
          <li>
            <span>GCP -</span> 
            <span>
                <a href='mailto:poorva.kulkarni'>poorva.kulkarni</a>
            </span>
            </li>
          <li><span>D&AI -</span>
          <span> 
          <a href='mailto:raju.chal'>raju.chal</a>,</br>
          <a href='mailto:pooja.a.joshi'>pooja.a.joshi</a>,</br>
          <a href='mailto:s.rajan.senthil'>s.rajan.senthil</a>,</br>
          <a href='mailto:s.prakashrao.jadhav'>s.prakashrao.jadhav</a>
          </span>
          </li>
        </ul>
      `,
    icon: "images/Contact/new-icons/Cloud-D&AI.png",
  },
  {
    id: 4,
    title: "For Entry-level Learning",
    content: `
        <ul>
          <li>
            <span>Tech Expressway -</span> 
            <span>
              <a href='mailto:L-TT.JobReadiness '>L-TT.JobReadiness </a>
            </span>
          </li>
          <li>
            <span>Entry level -</span> 
              <span>
                <a href='mailto:Rashi.Shrivastava'>Rashi.Shrivastava</a>
              </span>
          </li>
        </ul>
      `,
    icon: "images/Contact/new-icons/Entry-level-Learning.png",
  },
  {
    id: 5,
    title: "For BI & HS",
    content: `
        <ul>
          <li>
          <span>Business storytelling -</span> 
          <span>
            <a href='mailto:manoj.m.m'>manoj.m.m</a>
          </span>
          </li>
          <li>
          <span>Design thinking -</span> 
            <span>
              <a href='mailto:manoj.m.m'>manoj.m.m</a>
            </span>
          </li>
        </ul>
      `,
    icon: "images/Contact/new-icons/BI&HS.png",
  },
  {
    id: 6,
    title: "For L&TT Ops",
    content: `
      <ul>
        <li><span>Technology Training Operations -</span> 
          <span> 
            <a href='mailto:narendra.reddy.mutra'>narendra.reddy.mutra</a>,</br>
            <a href='mailto:m.snehalatha'>m.snehalatha</a>
          </span> 
        </li>
        <li><span>Industry Training Operations -</span> 
          <span> 
            <a href='mailto:srinivas.nanjappa'>srinivas.nanjappa</a>,</br>
            <a href='mailto:jeevan.shetty'>jeevan.shetty</a>
          </span> 
        </li>
        <li><span>Delivery Training Operations -</span> 
          <span> 
            <a href='mailto:john.m.peter'>john.m.peter</a>,</br>
            <a href='mailto:kavya.r.krishna'>kavya.r.krishna</a>
          </span> 
        </li>
        <li><span>BI&HS Training Operations -</span> 
          <span> 
            <a href='mailto:john.m.peter'>john.m.peter</a>,</br>
            <a href='mailto:megha.i.martiz'>megha.i.martiz</a>
          </span> 
        </li>
        <li><span>Language Training Operations -</span> 
          <span> 
            <a href='mailto:john.m.peter'>john.m.peter</a>,</br>
            <a href='mailto:megha.i.martiz'>megha.i.martiz</a>
          </span> 
        </li>
        <li><span>IE/ Security Training Operations -</span> 
          <span> 
            <a href='mailto:narendra.reddy.mutra'>narendra.reddy.mutra</a>,</br>
            <a href='mailto:sakshi.a.jain'>sakshi.a.jain</a>
          </span> 
        </li>
        <li><span>Certifications -</span> 
          <span> 
            <a href='mailto:narendra.reddy.mutra'>narendra.reddy.mutra</a>,</br>
            <a href='mailto:kr.sathyanarayana'>kr.sathyanarayana</a>
          </span> 
        </li>
        <li><span>BizInterlock Operations -</span> 
          <span> 
            <a href='mailto:narendra.reddy.mutra'>narendra.reddy.mutra</a>,</br>
            <a href='mailto:m.snehalatha'>m.snehalatha</a>
          </span> 
        </li>
        <li><span>Physical Training Infrastructure -</span> 
          <span> 
            <a href='mailto:narendra.reddy.mutra'>narendra.reddy.mutra</a>,</br>
            <a href='mailto:kr.sathyanarayana'>kr.sathyanarayana</a>
          </span> 
        </li>
        <li><span>Training Infrastructure (Cloud & Instances) -</span> 
          <span> 
            <a href='mailto:narendra.reddy.mutra'>narendra.reddy.mutra</a>,</br>
            <a href='mailto:eniyavan.ranganathan'>eniyavan.ranganathan</a>
          </span> 
        </li>
        <li><span>Automations / Tools -</span> 
          <span> 
            <a href='mailto:narendra.reddy.mutra'>narendra.reddy.mutra</a>,</br>
            <a href='mailto:sakshi.a.jain'>sakshi.a.jain</a>
          </span> 
        </li>
        <li><span>Learning Shared Service (LSS) -</span> 
          <span> 
            <a href='mailto:srinivas.nanjappa'>srinivas.nanjappa</a>,</br>
            <a href='mailto:jeevan.shetty'>jeevan.shetty</a>
          </span> 
        </li>
        <li><span>Information Resource Centre (IRC) -</span> 
          <span> 
            <a href='mailto:srinivas.nanjappa'>srinivas.nanjappa</a>,</br>
            <a href='mailto:m.k.chandrasekaran'>m.k.chandrasekaran</a>
          </span> 
        </li>
        <li><span>TechGenics - ShiftLeft -</span> 
          <span> 
            <a href='mailto:srinivas.nanjappa'>srinivas.nanjappa</a>,</br>
            <a href='mailto:bhagya.avinash'>bhagya.avinash</a>
          </span> 
        </li>
        <li><span>TechLeap -</span> 
          <span> 
            <a href='mailto:srinivas.nanjappa'>srinivas.nanjappa</a>,</br>
            <a href='mailto:varun.raghav'>varun.raghav</a>
          </span> 
        </li>
        <li><span>Vendor Management -</span> 
          <span> 
            <a href='mailto:john.m.peter'>john.m.peter</a>,</br>
            <a href='mailto:yashodha.shanmugam'>yashodha.shanmugam</a>
          </span> 
        </li>
        <li><span>Training Events Support -</span> 
          <span> 
            <a href='mailto:john.m.peter'>john.m.peter</a>,</br>
            <a href='mailto:yashodha.shanmugam'>yashodha.shanmugam</a>
          </span> 
        </li>
        <li><span>PMO Related -</span> 
          <span> 
            <a href='mailto:sangeetha.d.ravi'>sangeetha.d.ravi</a>,</br>
            <a href='mailto:jayasudha.devarajilu'>jayasudha.devarajilu</a>
          </span> 
        </li>
        <li><span>L&TT Helpline -</span> 
          <span> 
            <a href='mailto:narendra.reddy.mutra'>narendra.reddy.mutra</a>,</br>
            <a href='mailto:m.snehalatha'>m.snehalatha</a>
          </span> 
        </li>
      </ul>
    `,
    icon: "images/Contact/new-icons/L&TTOps.png",
  },
  {
    id: 7,
    title: "For Security Learning",
    content: `
    <ul>
        <li>
          <span>Security -</span> 
          <span>
            <a href='mailto:soma.tiwari'>soma.tiwari</a>,</br>
            <a href='mailto:sunil.l.singh'>sunil.l.singh</a>
            
          </span>
        </li>
      </ul>`,
    icon: "images/Contact/new-icons/SecurityLearning.png",
  },
  // {
  //   id: 9,
  //   title: "For Self-Paced Learning",
  //   content: `
  //   <ul>
  //       <li><span>Course -</span> <a href='mailto:dummy.xyz'>dummy.xyz</a></li>
  //       <li><span>Course -</span> <a href='mailto:dummy.xyz'>dummy.xyz</a></li>
  //     </ul>`,
  //   icon: "images/Contact/new-icons/tile-icon9.png",
  // },
  {
    id: 10,
    title: "For ATCI Song",
    content: `
    <ul>
        <li>
          <span>Digital Products -</span> 
          <span> 
            <a href='mailto:sindhu.s.nambiar'>sindhu.s.nambiar</a>,</br>
            <a href='mailto:mohana.krishnaveni'>mohana.krishnaveni</a>
          </span> 
        </li>
        <li>
          <span>Commerce -</span> 
          <span> 
            <a href='mailto:sindhu.s.nambiar'>sindhu.s.nambiar</a>,</br>
            <a href='mailto:mohan.chinnaiah'>mohan.chinnaiah</a>
          </span> 
        </li>
        <li>
          <span>Adobe -</span> 
          <span> 
            <a href='mailto:sindhu.s.nambiar'>sindhu.s.nambiar</a>,</br>
            <a href='mailto:p.c.khandelwal'>p.c.khandelwal</a>
          </span> 
        </li>
        <li>
          <span>Design -</span> 
          <span> 
            <a href='mailto:sindhu.s.nambiar'>sindhu.s.nambiar</a>,</br>
            <a href='mailto:kalpana.banka'>kalpana.banka</a>
          </span> 
        </li>
        <li>
          <span>Service -</span> 
          <span> 
            <a href='mailto:sindhu.s.nambiar'>sindhu.s.nambiar</a>,</br>
            <a href='mailto:mohana.krishnaveni'>mohana.krishnaveni</a>
          </span> 
        </li>
        <li>
          <span>EAI -</span> 
          <span> 
            <a href='mailto:sindhu.s.nambiar'>sindhu.s.nambiar</a>,</br>
            <a href='mailto:mohan.chinnaiah'>mohan.chinnaiah</a>
          </span> 
        </li>
        <li>
          <span>Pega -</span> 
          <span> 
            <a href='mailto:sindhu.s.nambiar'>sindhu.s.nambiar</a>,</br>
            <a href='mailto:v.deenabandu'>v.deenabandu</a>
          </span> 
        </li>
      </ul>`,
    icon: "images/Contact/new-icons/ATCISong.png",
  },
  {
    id: 11,
    title: "For LDE Next",
    content: `
    <ul>
        <li><span>LDE Next -</span> <a href='mailto:ATCI.LD.Experiences'>ATCI.LD.Experiences</a></li>
      </ul>`,
    icon: "images/Contact/new-icons/LDENext.png",
  },
  {
    id: 12,
    title: "For Sustainability",
    content: `
    <ul>
        <li><span>Sustainability -</span> 
        <span>
        <a href='mailto:augustine.srikanth'>augustine.srikanth</a>,</br>
        <a href='mailto:manisha.a.surve'>manisha.a.surve</a>
        </span>
        </li>
      </ul>`,
    icon: "images/Contact/new-icons/Sustainability.png",
  },
  {
    id: 13,
    title: "For Information Resource Center",
    content: `
    <ul>
        <li><span>Information Resource Center -</span> 
        <span>
        <a href='mailto:srinivas.nanjappa'>srinivas.nanjappa</a>,</br>
        <a href='mailto:m.k.chandrasekaran'>m.k.chandrasekaran</a>
        </span>
        </li>
      </ul>`,
    icon: "images/Contact/new-icons/InformationResourceCenter.png",
  },
  {
    id: 14,
    title: "For ATC GN",
    content: `
    <ul>
        <li><span>ATC GN -</span> 
        <span>
        <a href='mailto:amrutha.c.reddy'>amrutha.c.reddy</a>,</br>
        <a href='mailto:sharda.mankare'>sharda.mankare</a>
        </span>
        </li>
      </ul>`,
    icon: "images/Contact/new-icons/ATCGN.png",
  },
  {
    id: 15,
    title: "For Service Now",
    content: `
    <ul>
        <li><span>Service Now -</span> 
        <span>
        <a href='mailto:Sreenivasa.cpcl.rao'>Sreenivasa.cpcl.rao</a>,</br>
        <a href='mailto:j.ghosh'>j.ghosh</a>
        </span>
        </li>
      </ul>`,
    icon: "images/Contact/new-icons/ServiceNow.png",
  },
  {
    id: 16,
    title: "For Foreign Languages",
    content: `
    <ul>
        <li><span>Foreign Languages -</span> 
        <span>
        <a href='mailto:abhilash.d.bungale'>abhilash.d.bungale</a>,</br>
        <a href='mailto:shruti.aggarwal'>shruti.aggarwal</a>,</br>
        <a href='mailto:s.krishnakumari'>s.krishnakumari</a>
        </span>
        </li>
      </ul>`,
    icon: "images/Contact/new-icons/ForeignLanguages.png",
  },
  {
    id: 17,
    title: "For AI",
    content: `
    <ul>
        <li><span>AI -</span> 
        <span>
        <a href='mailto:shantanu.a.biswas'>shantanu.a.biswas</a>,</br>
        <a href='mailto:c.singh.sambyal'>c.singh.sambyal</a>,</br>
        <a href='mailto:gunjan.a.bansal'>gunjan.a.bansal</a>
        </span>
        </li>
      </ul>`,
    icon: "images/Contact/new-icons/AI.png",
  },
  {
    id: 18,
    title: "For Software Engineering",
    content: `
    <ul>
    <li>
      <span>Java -</span>
      <span> 
        <a href='mailto:r.c.narayanan'>r.c.narayanan</a>,</br>
        <a href='mailto:kirankumar.shejwal'>kirankumar.shejwal</a>,</br>
        <a href='mailto:jagadish.sanjeevi'>jagadish.sanjeevi</a>
      </span>
    </li>
      </ul>`,
    icon: "images/Contact/new-icons/SoftwareEngineering.png",
  },
  {
    id: 19,
    title: "For Infrastructure Engineering",
    content: `
    <ul>
      <li>
        <span>IE -</span>
        <span> 
          <a href='mailto:sreenivasa.cpcl.rao'>sreenivasa.cpcl.rao</a>
        </span>
      </li>
    </ul>`,
    icon: "images/Contact/new-icons/InfrastructureEngineering.png",
  },
  {
    id: 20,
    title: "For Quality Engineering",
    content: `
    <ul>
      <li>
        <span>QE -</span> 
        <span>
          <a href='mailto:sheela.ganesh.t'>sheela.ganesh.t</a>
        </span>
      </li>
    </ul>`,
    icon: "images/Contact/new-icons/QualityEngineering.png",
  },
  {
    id: 21,
    title: "For Learning Experiences",
    content: `
    <ul>
      <li>
        <span>Content Development -</span> 
        <span> 
          <a href='mailto:aparna.a.daptardar'>aparna.a.daptardar</a>,</br>
          <a href='mailto:priyanka.d.mukherjee'>priyanka.d.mukherjee</a>
        </span> 
      </li>
      <li>
        <span>ASPIRA and SPARCS -</span> 
        <span> 
          <a href='mailto:aparna.a.daptardar'>aparna.a.daptardar</a>.</br>
          <a href='mailto:yamini.garg'>yamini.garg</a>
        </span> 
      </li>
      <li>
        <span>Marketing and Communication -</span> 
        <span> 
          <a href='mailto:s.a.thiruveedhula'>s.a.thiruveedhula</a>,</br>
          <a href='mailto:ankita.rawat.garg'>ankita.rawat.garg</a>
        </span> 
      </li>
      <li>
        <span>Portal Development and Automations -</span> 
        <span> 
          <a href='mailto:h.srinivasan'>h.srinivasan</a>
        </span>
      </li>
    </ul>`,
    icon: "images/Contact/new-icons/LearningExperiences.png",
  },
];
